module.exports = __webpack_public_path__ + "static/media/i-think-therefore-i-am.1478fa0d.jpg";